import React from 'react';

const money = (value) =>
  new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    maximumFractionDigits: 0,
  }).format(Number(value || 0));

export default function ProductosTable({
  productos,
  cargando,
  onEditar,
  onStock,
}) {
  if (cargando) {
    return (
      <div className="rounded-2xl border border-blanco-puro/20 bg-azul-oscuro/60 p-8 text-center text-blanco-puro/70 shadow-xl backdrop-blur">
        Cargando productos...
      </div>
    );
  }

  if (!productos.length) {
    return (
      <div className="rounded-2xl border border-blanco-puro/20 bg-azul-oscuro/60 p-8 text-center shadow-xl backdrop-blur">
        <div className="text-sm font-bold text-amarillo-dorado">
          No hay productos
        </div>

        <div className="mt-1 text-xs text-blanco-puro/60">
          Creá el primero para comenzar a vender.
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-2xl border border-blanco-puro/20 bg-azul-oscuro/60 shadow-xl backdrop-blur">
      <div className="overflow-x-auto">
        <table className="w-full text-left text-blanco-puro">
          <thead className="border-b border-amarillo-dorado/40 bg-azul-oscuro/80 text-[11px] uppercase tracking-wide text-amarillo-dorado">
            <tr>
              <th className="px-4 py-3">Producto</th>
              <th className="px-4 py-3">Código</th>
              <th className="px-4 py-3 text-right">Precio</th>
              <th className="px-4 py-3 text-right">Stock</th>
              <th className="px-4 py-3 text-right">Stock mín.</th>
              <th className="px-4 py-3 text-right">Acciones</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-blanco-puro/10">
            {productos.map((producto) => {
              const stock = Number(producto.stock_actual || 0);
              const minimo = Number(producto.stock_minimo || 0);
              const stockBajo = stock <= minimo;

              return (
                <tr
                  key={producto.id}
                  className="transition hover:bg-blanco-puro/5"
                >
                  <td className="px-4 py-3">
                    <div className="font-semibold text-blanco-puro">
                      {producto.nombre}
                    </div>

                    <div className="text-[11px] text-blanco-puro/50">
                      {producto.categoria?.nombre || 'Sin categoría'}
                    </div>
                  </td>

                  <td className="px-4 py-3 text-xs text-blanco-puro/65">
                    {producto.codigo || '—'}
                  </td>

                  <td className="px-4 py-3 text-right text-sm font-bold text-blanco-puro">
                    {money(producto.precio)}
                  </td>

                  <td className="px-4 py-3 text-right">
                    <span
                      className={`inline-flex min-w-[60px] justify-center rounded-full border px-2.5 py-1 text-xs font-bold ${
                        stockBajo
                          ? 'border-red-300/40 bg-red-500/20 text-red-100'
                          : 'border-verde-esmeralda/40 bg-verde-esmeralda/20 text-emerald-100'
                      }`}
                    >
                      {stock}
                    </span>
                  </td>

                  <td className="px-4 py-3 text-right text-xs text-blanco-puro/60">
                    {minimo}
                  </td>

                  <td className="px-4 py-3">
                    <div className="flex justify-end gap-2">
                      <button
                        type="button"
                        onClick={() => onStock(producto)}
                        className="rounded-lg bg-amarillo-dorado px-3 py-1.5 text-xs font-bold text-azul-oscuro transition hover:bg-amber-400"
                      >
                        Stock
                      </button>

                      <button
                        type="button"
                        onClick={() => onEditar(producto)}
                        className="rounded-lg border border-blanco-puro/30 bg-blanco-puro/5 px-3 py-1.5 text-xs font-semibold text-blanco-puro transition hover:border-amarillo-dorado/70 hover:bg-blanco-puro/10 hover:text-amarillo-dorado"
                      >
                        Editar
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
